export default {
  name: "IndexActivity",
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};